<template>
    <base-box
        v-bind="$props"
        :border-color="getBorderColor"
        v-on="$listeners"
    >
        <template slot="content">
            <g-media-object>
                <template slot="left">
                    <g-icon name="exclamation-circle" :class="getIconClass" :style="getIconColorStyle" />
                </template>
                <template>
                    <g-typography tag="p" :value="message" />
                </template>
            </g-media-object>
        </template>
    </base-box>
</template>

<script>
    export default {
        name:  'ErrorMessageCard',
        props: {
            message: {
                type:     String,
                required: true,
            },
            color: {
                type: String,
            },
        },
        computed: {
            getBorderColor() {
                return this.color ? this.color : 'red';
            },
            getIconClass() {
                return this.color ? '' : 'error';
            },
            getIconColorStyle() {
                return 'color: ' + this.color;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .error {
        color: $g-font-color-error;
    }
</style>